export const ACCOUNT_DETAILS = "ACCOUNT_DETAILS";
export const ACCOUNT_DETAILS_ERROR = "ACCOUNT_DETAILS_ERROR";
export const ACCOUNT_DETAILS_HIDE_ERROR = "ACCOUNT_DETAILS_HIDE_ERROR";
export const ACCOUNT_DETAILS_START_LOADER = "ACCOUNT_DETAILS_START_LOADER";
export const ACCOUNT_DETAILS_STOP_LOADER = "ACCOUNT_DETAILS_STOP_LOADER";
